<template>
    <el-dialog @close="close" :title="modalTitle" :visible.sync="aide.isShow" :close-on-click-modal="false" :modal-append-to-body='false' :append-to-body="true" :width="modalWidth" :custom-class="modalClass">
        <div v-loading="lockLoading">
            <slot></slot>
        </div>
        <span slot="title" class="el-dialog__title" v-if="$slots.title">
            <span class="system-logo"></span>
            <slot name="title"></slot>
        </span>
        <div slot="title" class="el-dialog__title" v-else>
            <span class="system-logo"></span>
            <span>{{modalTitle}}</span>
        </div>
        <span slot="footer" class="dialog-footer" v-if="modalBtn.length">
            <el-button :disabled="disabled" v-if="modalBtn.includes('cancel')" @click="cancel" size='small'>{{ cancelText || '取 消'}} </el-button>
            <LoadingButton v-if="modalBtn.includes('submit')" :disabled="disabled_sub" :pLoading.sync="aide.loading" @callback="submitForm" :text="submitText" :countdown="countdown"/>
        </span>
    </el-dialog>
</template>

<script>
    import Vue, { Component } from 'C/BaseVue'
    import LoadingButton from 'C/LoadingButton'

    @Component({
        components: { LoadingButton },
        props: {
            aide : {
                type: Object,
                default: () => {}
            },
            lockLoading: {
                type: Boolean,
                required: false,
                default: ()=>{
                    return false
                }
            },
            modalTitle: {
                type: [String,Number],
                required: false,
                default: ()=>{
                    return '提示'
                }
            },
            modalWidth: {
                type: [String],
                required: false,
                default: ()=>{
                    return '50%'
                }
            },
            modalClass: {
                type: [String],
                required: false,
                default: ()=>{
                    return ''
                }
            },
            modalBtn: {
                type: [Array],
                required: false,
                default: ()=>{
                    return ['cancel','submit']
                }
            },
            submitText: {
                type: [String],
                required: false,
                default: ()=>{
                    return ''
                }
            },
            cancelText: {
                type: [String],
                required: false,
                default: ()=>{
                    return ''
                }
            },
            disabled: {
                type: Boolean,
                required: false,
                default: ()=>{
                    return false
                }
            },
            disabled_sub: {
                type: Boolean,
                required: false,
                default: ()=>{
                    return false
                }
            },
            countdown: {
                type: Number,
                default: () => { return 0 }
            }
            
        },
        watch: {
            aide : {
                handler(curVal, oldVal){},
                deep: true
            }
        },
    })

    export default class DialogModal extends Vue {
        
        mounted(){
        }

        cancel(){
            this.$emit('cancelHandle')
        }

        submitForm(){
            this.$emit('callback')
        }

        close(){
            this.$emit('closeCallback')
        }
    }

</script>
<style lang="scss" type="text/css" scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/DialogModal.vue